<template>
  <page-outline :title="title" :returnUrl="returnUrl">
    <payment-lmsg></payment-lmsg>
  </page-outline>
</template>

<script>
import PageOutline from '@/components/common/PageOutline'
import PaymentLMSG from '@/pages/requests/components/PaymentLMSG.vue'

export default {
  name: 'PagePaymentLMSG',
  components: {
    'page-outline': PageOutline,
    'payment-lmsg': PaymentLMSG
  },
  data () {
    return {
      title: this.$t('Homepage.invoices'),
      returnUrl: '/home/'
    }
  }
}
</script>
